import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  useGetNumbersByCampaignQuery,
  useGetNumbersBySearchQuery,
  useGetDownloadCampaignCSVMutation,
  useGetCustomerLogDeleteKeyQuery,
  useCheckFailedRefundQuery,
} from "../store/services/reportApi";
import {
  useGetClickerNumbersByCampaignQuery,
  useDownloadClickerCampaignCSVMutation, // Add this import
} from "../store/services/clickerApi";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Loader from "../component/common/Loader";
import { cellSX, layoutCSS } from "../component/common/commonStyle";
import { maskNumberAdvanced } from "../component/common/Encryption";

const statusOptions = ["DELIVRD", "FAILED", "AWAITED"];

const FAILED_STAT_GROUP = [
  "FAILED",
  "ERROR",
  "UNDELIV",
  "EXPIRED",
  "UNKNOWN",
  "REJECTED",
  "NDNC",
];

const NumbersByCampaignPage = () => {
  const { state } = useLocation();
  const post_via = state?.post_via || "";
  console.log(post_via, "post_via");
  const reportType = state?.reportType || "sms";

  const { campaign_id } = useParams();
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [page, setPage] = useState(1);
  const [searchNumber, setSearchNumber] = useState("");
  const navigate = useNavigate();
  // SMS download mutation
  const [downloadCSV, { isLoading: isLoadindDownLoadCSV }] =
    useGetDownloadCampaignCSVMutation();

  // Clicker download mutation
  const [downloadClickerCSV, { isLoading: isDownloadingClickerCSV }] =
    useDownloadClickerCampaignCSVMutation();

  const { data: deleteKeyData } = useGetCustomerLogDeleteKeyQuery();
  const showMobileNumber =
    String(deleteKeyData?.data?.show_mobile_number) === "true";
  const buildClickerStatParam = (selected) => {
    let statList = [];

    selected.forEach((status) => {
      const upperStatus = status?.toUpperCase();

      if (upperStatus === "FAILED") {
        statList.push("FAILED", "UNDELIV", "ERROR");
      } else if (upperStatus === "AWAITED") {
        statList.push("AWAITED");
      } else if (upperStatus === "PENDING") {
        statList.push("SMSC", "SUBMITTED");
      } else {
        statList.push(upperStatus);
      }
    });

    return statList.join(",");
  };
  const buildStatParam = (selected) => {
    let statList = [];

    selected.forEach((status) => {
      const s = status.toUpperCase();

      if (s === "FAILED") {
        statList.push(
          "FAILED",
          "ERROR",
          "UNDELIV",
          "EXPIRED",
          "UNKNOWN",
          "REJECTD",
          "NDNC",
        );
      } else if (s === "AWAITED") {
        statList.push("AWAITED", "SMSC");
      } else {
        statList.push(s);
      }
    });

    return [...new Set(statList)].join(",");
  };
  // SMS Campaign Query
  const {
    data: campaignData,
    isLoading: campaignLoading,
    isError: campaignError,
  } = useGetNumbersByCampaignQuery(
    {
      campaign_id,
      page,
      stat:
        selectedStatus.length > 0 ? buildStatParam(selectedStatus) : undefined,
    },
    { skip: reportType !== "sms" },
  );

  // Clicker Campaign Query
  const {
    data: clickerCampaignData,
    isLoading: clickerCampaignLoading,
    isError: clickerCampaignError,
  } = useGetClickerNumbersByCampaignQuery(
    {
      clicker_campaign_id: campaign_id,
      page,
      status:
        selectedStatus.length > 0 ? buildClickerStatParam(selectedStatus) : "",
    },
    { skip: reportType !== "clicker" },
  );

  useEffect(() => {
    if (reportType === "clicker") {
      console.log("CLICKER STATUS FILTER:", selectedStatus);
    }
  }, [selectedStatus]);

  const {
    data: searchData,
    isLoading: searchLoading,
    isError: searchError,
    error: searchErrObj,
  } = useGetNumbersBySearchQuery(
    { campaign_id, ph_no: searchNumber },
    { skip: !searchNumber || reportType !== "sms" },
  );

  // Refund check query
  const { data: failedRefundData, isLoading } = useCheckFailedRefundQuery();

  const isFailedRefund = failedRefundData?.isFailedRefund === true;
  console.log("isFailedRefund:", isFailedRefund);

  useEffect(() => {
    if (searchNumber) setPage(1);
  }, [searchNumber]);

  const currentCampaignData =
    reportType === "sms" ? campaignData : clickerCampaignData;
  const currentCampaignLoading =
    reportType === "sms" ? campaignLoading : clickerCampaignLoading;
  const currentCampaignError =
    reportType === "sms" ? campaignError : clickerCampaignError;

  const handleStatusChange = (event) => {
    const { value, checked } = event.target;
    setSelectedStatus((prev) =>
      checked ? [...prev, value] : prev.filter((s) => s !== value),
    );
    setPage(1);
  };

  const handlePageChange = (_, value) => setPage(value);

  const calculateStatusCounts = (data = {}) => {
    const statSummary = data.statSummary || {};

    return {
      DELIVRD: statSummary.DELIVRD || 0,
      FAILED: statSummary.FAILED || 0,
      AWAITED: statSummary.AWAITED || 0,
    };
  };

  const statusCounts = calculateStatusCounts(currentCampaignData);
  const totalAllCount =
    statusCounts.DELIVRD + statusCounts.FAILED + statusCounts.AWAITED;

  const isSearchMode = Boolean(searchNumber) && reportType === "sms";
  const noMatch =
    isSearchMode &&
    (searchData?.status === false ||
      (searchError &&
        (searchErrObj?.status === 404 ||
          searchErrObj?.originalStatus === 404)));

  const rowsToRender = isSearchMode
    ? noMatch
      ? [] // show nothing
      : searchData?.data || []
    : currentCampaignData?.data || [];

  const handleStatusLabelClick = (status) => {
    setSelectedStatus((prev) => {
      const alreadySelected = prev.includes(status);
      const newSelection = alreadySelected
        ? prev.filter((s) => s !== status)
        : [...prev, status];
      return newSelection;
    });
    setPage(1);
  };

  const getStatus = (status) => {
    if (!status) return "Submitted";
    return status;
  };
  const handleDownloadCSV = async () => {
    try {
      const statParam =
        selectedStatus.length > 0
          ? reportType === "sms"
            ? buildStatParam(selectedStatus)
            : buildClickerStatParam(selectedStatus)
          : undefined;

      if (reportType === "sms") {
        const response = await downloadCSV({
          campaign_id,
          stat: statParam,
        }).unwrap();

        const blob = new Blob([response], { type: "text/csv" });
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = `campaign_${campaign_id}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(blobUrl);
      } else if (reportType === "clicker") {
        const response = await downloadClickerCSV({
          clicker_campaign_id: campaign_id,
          status: statParam,
        }).unwrap();

        const blob = new Blob([response], { type: "text/csv" });
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = `clicker_campaign_${campaign_id}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(blobUrl);
      }
    } catch (err) {
      console.error("Download error:", err);
      alert("Failed to download CSV. Try again.");
    }
  };
  const showErrCols = (rowsToRender || []).some(
    (r) => r?.errcode != null || r?.errDescription != null,
  );

  if (isLoadindDownLoadCSV || isDownloadingClickerCSV) {
    return <Loader />;
  }
  const allowLiveReport =
    String(deleteKeyData?.data?.allow_live_report) === "true" ||
    deleteKeyData?.data?.allow_live_report === true;
  const isSubmittedOnly = selectedStatus.length === 0;
  const showErrorCodeCol = allowLiveReport && !isSubmittedOnly;
  const showRefundCol = allowLiveReport && !isSubmittedOnly && isFailedRefund;

  return (
    <Box sx={layoutCSS}>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <IconButton
          onClick={() => navigate(-1)}
          size="small"
          aria-label="Go back"
          sx={{ color: "inherit" }}
        >
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <Typography variant="h6" sx={cellSX}>
          Campaign: {campaign_id} ({reportType.toUpperCase()})
        </Typography>
      </Box>

      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={selectedStatus.length === 0}
              onChange={() => setSelectedStatus([])}
              sx={{ p: 0.5 }}
            />
          }
          label={
            <span
              style={{ cursor: "pointer", fontSize: "0.75rem" }}
              onClick={() => setSelectedStatus([])}
            >
              {`SUBMITTED (${totalAllCount})`}
            </span>
          }
        />

        {allowLiveReport &&
          statusOptions.map((status) => (
            <FormControlLabel
              key={status}
              control={
                <Checkbox
                  size="small"
                  checked={selectedStatus.includes(status)}
                  onChange={handleStatusChange}
                  value={status}
                  sx={{ p: 0.5 }}
                />
              }
              label={
                <span
                  style={{ cursor: "pointer", fontSize: "0.75rem" }}
                  onClick={() => handleStatusLabelClick(status)}
                >
                  {`${status} (${statusCounts[status]})`}
                </span>
              }
            />
          ))}
        {reportType === "sms" && (
          <TextField
            label="Search Phone Number"
            size="small"
            variant="outlined"
            sx={{
              width: 130,
              fontSize: "0.75rem",
              "& .MuiInputBase-input": {
                fontSize: "0.75rem",
                padding: "6px 8px",
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.75rem",
              },
            }}
            value={searchNumber}
            onChange={(e) => setSearchNumber(e.target.value)}
          />
        )}
        <Box>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", marginLeft: 3 }}
          >
            <Button
              variant="contained"
              color="success"
              onClick={handleDownloadCSV}
              disabled={
                currentCampaignLoading ||
                isLoadindDownLoadCSV ||
                isDownloadingClickerCSV
              }
              sx={{
                width: 140,
                fontSize: "0.75rem",
                textTransform: "none",
                padding: "6px 12px",
              }}
            >
              Download CSV
            </Button>
          </Box>
        </Box>
      </FormGroup>

      {/* Table rendering remains the same */}
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: 2,
          border: "1px solid #e0e0e0",
          mt: 2,
        }}
      >
        <Table>
          <TableHead
            sx={{
              bgcolor: "#0288d1",
              "& th": {
                color: "white",
                fontSize: "0.8rem",
                borderBottom: "0.5px solid #B0B0B0",
                padding: "8px",
                borderRight: "0.5px solid #B0B0B0",
              },
            }}
          >
            <TableRow>
              <TableCell>Created At</TableCell>
              <TableCell>Phone Number</TableCell>
              <TableCell>Sender ID</TableCell>
              {post_via === "customize" && <TableCell>SMS Text</TableCell>}
              <TableCell>Status</TableCell>
              <TableCell sx={{ width: "120px" }}>Status updated Time</TableCell>
              {(post_via === "customize" || reportType === "clicker") && (
                <TableCell>Msg Count</TableCell>
              )}
              {reportType === "clicker" && <TableCell>Click Count</TableCell>}
              {showErrorCodeCol && <TableCell>Error Code</TableCell>}
              {showErrorCodeCol && <TableCell>Error Description</TableCell>}
              {showRefundCol && <TableCell>Refund Balance</TableCell>}
            </TableRow>
          </TableHead>

          <TableBody>
            {searchNumber && searchLoading ? (
              <TableRow>
                <TableCell colSpan={7}>Loading...</TableCell>
              </TableRow>
            ) : isSearchMode && noMatch ? null : currentCampaignLoading &&
              !searchNumber ? (
              <TableRow>
                <TableCell colSpan={7}>Loading...</TableCell>
              </TableRow>
            ) : currentCampaignError ? (
              <TableRow>
                <TableCell colSpan={7}>No numbers found</TableCell>
              </TableRow>
            ) : rowsToRender.length > 0 ? (
              rowsToRender.map((num, index) => {
                const displayStatus = getStatus(num.stat);

                return (
                  <TableRow key={index}>
                    <TableCell sx={cellSX}>
                      {num.createdat && (
                        <>
                          {new Date(num.createdat).toLocaleDateString("en-GB")}
                          <br />
                          {new Date(num.createdat).toLocaleTimeString("en-GB")}
                        </>
                      )}
                    </TableCell>

                    <TableCell sx={cellSX}>
                      {showMobileNumber
                        ? num.ph_no
                        : maskNumberAdvanced(num.ph_no)}
                    </TableCell>

                    <TableCell sx={cellSX}>{num.sender_id}</TableCell>

                    {post_via === "customize" && (
                      <TableCell sx={cellSX}>{num?.smstext}</TableCell>
                    )}

                    <TableCell sx={cellSX}>
                      {isSubmittedOnly ? "Submitted" : getStatus(num.stat)}
                    </TableCell>

                     
                      <TableCell sx={cellSX}>{num.done_date ?? ""}</TableCell>
                    

                    {(post_via === "customize" || reportType === "clicker") && (
                      <TableCell sx={cellSX}>{num?.msgcount || 0}</TableCell>
                    )}

                    {reportType === "clicker" && (
                      <TableCell sx={cellSX}>{num?.click_count || 0}</TableCell>
                    )}

                    {showErrorCodeCol && (
                      <TableCell sx={cellSX}>{num.errcode ?? ""}</TableCell>
                    )}

                    {showErrorCodeCol && (
                      <TableCell sx={cellSX}>{num.errDescription ?? ""}</TableCell>
                    )}

                    {showRefundCol && (
                      <TableCell sx={cellSX}>
                        {num.refundbalance ?? ""}
                      </TableCell>
                    )}
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={7}>No numbers found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {currentCampaignData?.totalPages > 1 && !searchNumber && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={currentCampaignData.totalPages}
            page={page}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default NumbersByCampaignPage;